// extracted by mini-css-extract-plugin
export default {"contactContainer":"contact_contactContainer__sAFXI","inputCon":"contact_inputCon__Y5Vs1"};